export const GA_ACTION_SKIPPED = 'Skipped'
export const GA_ACTION_COMPLETED = 'Completed'



// WEBPACK FOOTER //
// ./hoc/WithInputAnalytics/constants.js